import { render, staticRenderFns } from "./user-permission-table.vue?vue&type=template&id=61e0514c"
import script from "./user-permission-table.vue?vue&type=script&lang=js"
export * from "./user-permission-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports